import { SET_ACCEPT_COOKIE } from './constants';

const reducer = (state = false, { type, payload }) => {
  switch (type) {
    case SET_ACCEPT_COOKIE:
      return Boolean(payload);

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/app/acceptCookies/reducer.js